const getListOfAvailableCurrencies = (prices, futurePrices) => {
  const availableCurrencies = {
    NOK: false,
    EUR: false,
    USD: false
  };
  const listOfAvailableCurrencies = [];

  // Use `.map()` for prices
  prices.map(item => {
    if (parseFloat(item.value) > 0) {
      availableCurrencies[item.currency.currency] = true;
    }
    return null; // To avoid unused return warning in .map()
  });

  // Use `.forEach()` for futurePrices
  futurePrices?.forEach(item => {
    if (item.ratePlanPrices && Array.isArray(item.ratePlanPrices)) {
      item.ratePlanPrices.forEach(price => {
        if (parseFloat(price.value) > 0) {
          availableCurrencies[price.currency.currency] = true;
        }
      });
    }
  });

  Object.keys(availableCurrencies).forEach(key => {
    if (availableCurrencies[key]) {
      listOfAvailableCurrencies.push(key);
    }
  });

  return listOfAvailableCurrencies;
};

export { getListOfAvailableCurrencies };
